
const services = [
  {
    icon: 'ri-hammer-fill',
    title: 'Structural Steel Welding',
    description: 'Code-compliant structural steel welding for commercial construction, industrial facilities, and municipal infrastructure projects.',
  },
  {
    icon: 'ri-tools-fill',
    title: 'Custom Metal Fabrication',
    description: 'Precision custom fabrication — from concept to completion. Steel, aluminum, and specialty metals built to your exact specifications.',
  },
  {
    icon: 'ri-truck-fill',
    title: 'Mobile Welding Repair',
    description: 'On-site mobile welding services across Northern and Southern California. We come to your job site — 24/7 emergency response available.',
  },
  {
    icon: 'ri-settings-3-fill',
    title: 'Heavy Equipment Repair',
    description: 'Keep your fleet running. Expert heavy equipment welding repair for excavators, loaders, dozers, and all construction machinery.',
  },
  {
    icon: 'ri-scissors-cut-fill',
    title: 'CNC Plasma & Torch Cutting',
    description: 'High-precision CNC plasma and torch cutting services for clean, accurate cuts on steel plate, structural shapes, and custom parts.',
  },
  {
    icon: 'ri-home-gear-fill',
    title: 'Custom Gates & Fencing',
    description: 'Durable custom metal gates, security fencing, handrails, and ornamental ironwork for residential and commercial properties.',
  },
  {
    icon: 'ri-plant-fill',
    title: 'AG Equipment Fabrication',
    description: 'Agricultural equipment fabrication and repair — implements, frames, attachments, and custom AG builds for farming operations.',
  },
  {
    icon: 'ri-stairs-fill',
    title: 'Staircases & Handrails',
    description: 'Custom-built metal staircases, industrial handrails, and safety railings — code-compliant and built to last for commercial projects.',
  },
];

export default function Services() {
  return (
    <section id="services" className="py-24 bg-[#1A1A1A]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-10 h-0.5 bg-[#E8740C]"></div>
            <span className="text-[#E8740C] text-xs font-semibold tracking-[0.2em] font-heading uppercase">What We Do</span>
            <div className="w-10 h-0.5 bg-[#E8740C]"></div>
          </div>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-white leading-tight mb-4">
            FULL-SERVICE <span className="text-[#E8740C]">WELDING</span> &amp; FABRICATION
          </h2>
          <p className="text-white/60 text-sm max-w-2xl mx-auto leading-relaxed font-body">
            From structural steel erection to emergency mobile welding repair — we deliver contractor-grade welding services that keep your projects on schedule and within budget.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {services.map((service) => (
            <article
              key={service.title}
              className="group bg-[#242424] border border-white/5 rounded-lg p-6 hover:border-[#E8740C]/40 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-[#E8740C]/10 rounded-lg mb-5 group-hover:bg-[#E8740C]/20 transition-colors">
                <i className={`${service.icon} text-[#E8740C] text-xl`}></i>
              </div>
              <h4 className="font-heading font-bold text-white text-base mb-3">
                <a href="#request-quote" className="hover:text-[#E8740C] transition-colors cursor-pointer">{service.title}</a>
              </h4>
              <p className="text-white/50 text-xs leading-relaxed font-body">{service.description}</p>
            </article>
          ))}
        </div>

        <div className="mt-12 bg-[#E8740C]/10 border border-[#E8740C]/20 rounded-lg p-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-add-circle-fill text-[#E8740C] text-xl"></i>
            </div>
            <p className="text-white text-sm font-medium">
              <strong>Also available:</strong> Pick-up &amp; Delivery, Saw Cutting, Tube Bending, Powder Coating, Ornamental Ironwork &amp; more
            </p>
          </div>
          <a
            href="tel:5308068659"
            className="text-[#E8740C] font-heading font-bold text-sm tracking-wider hover:text-[#d16a0b] transition-colors cursor-pointer whitespace-nowrap"
          >
            CALL 530-806-8659 →
          </a>
        </div>
      </div>
    </section>
  );
}
